import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss', './how-it-works-modal-mode.component.scss']
})
export class HowItWorksComponent {
  @Input() isCursorPointer: boolean = true;
  @Input() modalMode: boolean = false;
}
